module.exports = __webpack_public_path__ + "img/avatar1.0ad0bed6.png";